<div class="position-relative" style="overflow: hidden">
  <div class="d-flex flex-column p-3 wrapper">
    @if(currentPageNum == 1){
      <p class="title">
        <img class="img-circle shadow-lg" loading="lazy" src="../../../../../assets/images/w.jpeg" alt="" />
        Select/Recommend products({{ totalAttachedProductsNum }}/{{MAX_SELECTED_PRODUCT}})
      </p>
  
      <div class="input-basic mx-3 my-3">
        <input type="text" placeholder="Search" class="w-100 form-control" [(ngModel)]="searchString" (keyup)="getProducts()" />
      </div>
  
      <div class="mb-3 prods" *ngIf="products.length">
        <common-product-card-view *ngFor="let list of products" (view)="selectProduct($event)"
         [class.selected]="isSelected(list)" [list]="list"> </common-product-card-view>
      </div>
      <div class="my-4 w-100 text-center p-5" style="font-size: 1.5rem" *ngIf="products.length == 0">
        No Product found
        <!-- <button class="btn btn-outline-secondary" (click)="openRecommendation()"><i class="fa fa-plus"></i> Recommend</button> -->
      </div>
     
      <div class="bottom">
        <div *ngIf="recommendedProducts?.length" class="my-2 d-flex flex-column">
          Recommended:
          <div class="d-flex flex-wrap" style="gap: .5rem;">
            <button class="t-btn" *ngFor="let recomm of recommendedProducts">
              {{recomm.nameOfServiceProvider}} 
              <button class="t-btn " (click)="removeRecomm(recomm)"><i class="fa fa-trash"></i></button>
            </button>
    
          </div>
        </div>
        <div class="d-flex w-100 justify-content-between p-2 my-2">
  
          <button class="btn btn-outline-secondary" (click)="openRecommendation()"><i class="fa-regular fa-star"></i>  Recommend  A Product Instead</button>
          <button class="btn btn-outline-secondary" (click)="goToPage(2)">Next <i class="fa fa-arrow-right"></i></button>
  
        </div>
    
      </div>

    }@else if(currentPageNum == 2){
      <div class="d-flex w-100">
        <button class="t-btn" (click)="goToPage(1)"><i class="fa fa-arrow-left"></i> Back</button> 
      </div>
      <p class="title">
      
        Can You Tell Us The Reasons For Selecting Each Of these Products</p>
      <div class="reasons">        
        <textarea 
          rows="5"
        *ngFor="let prod of allAttached; index as reasonIndex"
         [placeholder]="'Reason for selecting ' + (prod?.name || prod?.nameOfServiceProvider)"
         [(ngModel)]="reasons[reasonIndex]"
        
         ></textarea>
      </div>

      <div class="d-flex w-100 justify-content-end p-2 my-2">
        <button class="btn btn-outline-secondary" (click)="goToPage(3)">Next <i class="fa fa-arrow-right"></i></button>
      </div>


    }@else if(currentPageNum == 3){

    }

  </div>
</div>
